import { getCities } from '../../api/authApi'
import NavBar from '../../components/nav-bar/nav-bar'
import translate from '../../i18n'
import { setActiveCitiesAction } from '../../store/city/action'
import { Card, Space } from 'antd'
import { useEffect } from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { Outlet, useLocation } from 'react-router-dom'
import { compose } from 'redux'

const CardStacksContainer = (props: ConnectedProps<typeof withConnect>) => {
  const location = useLocation()

  const getNavBarTitle = () => {
    const pathName = location.pathname
    if (pathName.match(/^\/card-stacks\/[0-9]+$/)) {
      return translate('navBar.viewCardStackTitle')
    }
    if (pathName.match(/^\/card-stacks\/new$/)) {
      return translate('navBar.newCardStack')
    }
    if (pathName.match(/^\/card-stacks\/[0-9]+\/edit$/)) {
      return translate('navBar.editCardStack')
    }
    return translate('navBar.cardStacksTitle')
  }

  useEffect(() => {
    getCities().then(res => {
      const { setActiveCitiesAction } = props
      setActiveCitiesAction(res)
    })
  }, [])

  return (
    <Space className="dashboard-wrapper" orientation="vertical">
      <NavBar title={getNavBarTitle()}></NavBar>
      <Card>
        <Outlet />
      </Card>
    </Space>
  )
}

const mapDispatchToProps = {
  setActiveCitiesAction,
}

const withConnect = connect(null, mapDispatchToProps)

export default compose(withConnect)(CardStacksContainer)
